// 运营-报警列表api
import request from '@/util/request'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel
export function cancelRequest () {
	if (typeof cancel === 'function') {
		// 取消请求
		cancel()
	  }
}

export function apiGetList(dir,ppt,size,page,data){ //设备报警列表
	return request({
		url: `/device-s/device/alert/list`,
		method:"post",
		params:{
			"order.direction":dir,
			"order.property":ppt,
			size,
			page
		},
		data
	});
}

//报警详情 
export function baseInfoGet(data){
	return request({
		url:`/device-s/device/alert/detail`,
		method:'post',
		data
	})
}

//报警时间分布图表数据 
export function timelineDataGet(data){
	return request({
		url:`/device-s/device/alert/timeline`,
		method:'post',
		data
	})
}


// WEBPACK FOOTER //
// ./src/api/device/alarm/list.js